var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@material-ui/core';
function wrapWithSvgIcon(component, props) {
    return React.createElement(SvgIcon, __assign({}, props), component);
}
function SvgEmptyState(props) {
    return wrapWithSvgIcon(React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 72 72", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.6 8.1h46.8a4.5 4.5 0 014.5 4.5v4.512H8.1V12.6a4.5 4.5 0 014.5-4.5zM8.1 21.612V59.4a4.5 4.5 0 004.5 4.5h1.508V43.881a1.751 1.751 0 113.503 0V63.9h8.756V33.373a1.751 1.751 0 113.503 0V63.9h10.509V43.881a1.751 1.751 0 113.503 0V63.9h10.506V50.886a1.751 1.751 0 013.502 0V63.9h1.51a4.5 4.5 0 004.5-4.5V21.612H8.1zM29.87 68.4H59.4a9 9 0 009-9V12.6a9 9 0 00-9-9H12.6a9 9 0 00-9 9v46.8a9 9 0 009 9H29.87z", fill: "#191919" })), props);
}
export default SvgEmptyState;
//# sourceMappingURL=EmptyState.js.map